// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.drawer_dialog[data-v-4c4fdf62] {\n  height: 100%;\n}\n.batchNumber[data-v-4c4fdf62] {\n  color: #007efd;\n  cursor: pointer;\n}\n.remarkStyle p[data-v-4c4fdf62] {\n  padding: 0!important;\n  margin: 0!important;\n}\n", ""]);
// Exports
module.exports = exports;
